import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import PasscodeScreen from "@/components/PasscodeScreen";
import Dashboard from "@/pages/Dashboard";
import DockPage from "@/pages/DockPage";

function AuthGate() {
  const { isAuthenticated, isChecking } = useAuth();

  if (isChecking) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-slate-50">
        <div className="h-8 w-8 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <PasscodeScreen />;
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-background">
        <AuthProvider>
          <Routes>
            {/* Dock page has its own auth - accessible without main passcode */}
            <Route path="/dock" element={<DockPage />} />
            {/* All other routes require main passcode */}
            <Route path="/*" element={<AuthGate />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;
